export const MOBILE_ENTITY_TYPE: IEntityType = 'mobile';
export const PC_ENTITY_TYPE: IEntityType = 'pc';
export const CONSOLE_ENTITY_TYPE: IEntityType = 'console';
export const COMBINE_ENTITY_TYPE: IEntityType = 'combine';

export const STEAM_PLATFORM: IPlatform = 'steam';
export const EPIC_PLATFORM: IPlatform = 'epic';
export const PC_PLATFORMS: IPlatform[] = [STEAM_PLATFORM, EPIC_PLATFORM];

export const PLAYSTATION_PLATFORM = 'playstation';
export const XBOX_PLATFORM = 'xbox';
export const NINTENDO_PLATFORM = 'nintendo';
export const CONSOLE_PLATFORMS: IPlatform[] = [PLAYSTATION_PLATFORM, XBOX_PLATFORM, NINTENDO_PLATFORM];

export const COMBINE_PLATFORMS: IPlatform[] = [...PC_PLATFORMS, ...CONSOLE_PLATFORMS];
